import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './FeedModal.css';
import ModalCloseIcon from './icon-modal-close.svg';
import { Modal, Alert } from 'react-bootstrap';
import ImageUpload from '../../components/ImageUpload';
import MessageForm from '../../components/MessageForm';
import { MESSAGE_TYPE_IMAGE_CAPTION } from '../../components/MessageForm';
import AddMediaIcon from '../../components/MessageForm/icon-add-media.svg';
import { getToken } from '../../utils/auth';
import LoadingIndicator from '../../components/LoadingIndicator';

class FeedModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      file: null,
      uploadRequested: false,
      uploadFailedError: null
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleImageDrop = this.handleImageDrop.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  handleChange(event) {
    this.setState({
      message: event.target.value
    });
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' && event.shiftKey === false) {
      this.handleSubmit(event);
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({
      uploadRequested: true
    });

    this.uploadImage();
  }

  handleImageDrop(file) {
    this.setState({
      file
    });
  }

  uploadImage() {
    const token = getToken();
    const { file } = this.state;

    const formData = new FormData();
    formData.append('picture', file);
    fetch(process.env.REACT_APP_API_URI + '/uploadWallImage', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      credentials: 'same-origin', // For maintenance cookie
      body: formData
    })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(response => {
        return response.json();
      })
      .then(json => {
        const { message } = this.state;
        const { makeWallPost } = this.props;

        if (json.imageKey) {
          makeWallPost(message, json.imageKey);
          this.onClose();
        }
      })
      .catch(error => {
        this.setState({
          uploadFailedError: error,
          uploadRequested: false
        });
      });
  }

  onClose() {
    const { onHide } = this.props;

    this.setState({
      message: '',
      uploadRequested: false,
      file: null,
      uploadFailedError: null
    });

    onHide();
  }

  render() {
    const { onHide, makeWallPost, ...otherProps } = this.props;
    const { uploadRequested, uploadFailedError } = this.state;

    return (
      <Modal {...otherProps}>
        <Modal.Header>
          <div className="icon-add-media-container">
            <img
              className="add-media-icon"
              src={AddMediaIcon}
              alt="Add Media Icon"
            />
            <span>Upload a Picture</span>
          </div>
          <div className="icon-modal-close-container">
            <img
              className="modal-close-icon"
              onClick={this.onClose}
              src={ModalCloseIcon}
              alt="Close Icon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {uploadFailedError && (
            <Alert bsStyle="danger">
              {uploadFailedError.response.status === 413
                ? 'The uploaded file is too large.'
                : 'The file upload failed.'}
            </Alert>
          )}
          {uploadRequested && <LoadingIndicator overlay />}
          <ImageUpload
            handleImageDrop={this.handleImageDrop}
            onSubmit={this.submit}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="feed-comment-container image-caption-form">
            <MessageForm
              onSubmit={this.handleSubmit}
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              message={this.state.message}
              placeholder={MESSAGE_TYPE_IMAGE_CAPTION}
              disabled={uploadRequested}
            />
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

FeedModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  makeWallPost: PropTypes.func.isRequired,
  // Modal props
  closeButton: PropTypes.bool,
  show: PropTypes.bool
};

export default FeedModal;



// WEBPACK FOOTER //
// ./src/components/FeedModal/index.js